export function getErrorMessage(
	errorData: unknown,
	excludeKeys: string[] = [],
): string {
	if (!errorData) return 'Неизвестная ошибка'

	if (typeof errorData === 'string') {
		const lowered = errorData.toLowerCase()
		if (
			lowered.includes('<html') ||
			lowered.includes('<body') ||
			lowered.includes('<!doctype html')
		) {
			return 'Неизвестная ошибка'
		}
		return errorData
	}

	if (Array.isArray(errorData)) return errorData.join(', ')

	if (typeof errorData === 'object' && errorData !== null) {
		return (
			Object.entries(errorData)
				.filter(([key]) => !excludeKeys.includes(key))
				.map(([, value]) => {
					if (Array.isArray(value)) return value.join(', ')
					if (typeof value === 'string') {
						const lowered = value.toLowerCase()
						if (
							lowered.includes('<html') ||
							lowered.includes('<body') ||
							lowered.includes('<!doctype html')
						) {
							return 'Неизвестная ошибка'
						}
						return value
					}
					return JSON.stringify(value)
				})
				.join('; ') || 'Неизвестная ошибка'
		)
	}

	return 'Неизвестная ошибка'
}
